<div
	class="flex flex-col gap-5 rounded-xl border-grey bg-grey-veryLight p-5 mt-5 item-center justify-center mb-5"
>
	<div class="flex flex-col items-center justify-center px-10 gap-5">
		<app-icon [icon]="ICON.CANCEL" class="text-red text-4xl"></app-icon>
		<p class="text-xl font-bold">Cancelled</p>
		<p>
			Your order is cancelled. Submit a new order or change providers, if
			desired.
		</p>
	</div>
	<div class="flex flex-col items-center justify-center px-10 gap-5">
		<app-button
			(click)="reactivateOrder()"
			[icon]="ICON.RESEND"
			[testHook]="testHooks.ReactivateOrderButton"
			>Reactivate order</app-button
		>
		<div class="w-3/4 mx-auto flex gap-2 items-center justify-between mt-1">
			<hr class="w-1/2 mt-2" />
			<p>OR</p>
			<hr class="w-1/2 mt-2" />
		</div>
		<app-title-plus-footer [allowCancel]="false"></app-title-plus-footer>
	</div>
</div>
